//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Color",1,0],[0,"CreationType",1,0],[0,"EnableRepeatTime",1,0],[0,"Name",1,0],[0,"RepeatTime",1,0],[1,"SelectObject",0,"SelectNXObjectList",0]],[[["index"],"CreateBar",{},1,0],[["bars"],"DeleteBars",{},1,0],[["index","color"],"SetBarStartColor",{},2,0],[["index","color"],"SetBarEndColor",{},2,0],[["index","name"],"SetBarName",{},2,0],[["index","start_time"],"SetBarStartTime",{},2,0],[["index","end_time"],"SetBarEndTime",{},2,0],[["bars","mirror_time"],"MirrorBars",{},2,0],[["index","split_time"],"SplitBar",{},2,0]],[]];
SPLM.AnimationDesigner.AnimatedColorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.AnimatedColorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.AnimatedColorBuilder.CreationTypes = Object.freeze({
    "CreateaSingleAnimatedColorEffect" : "CreateaSingleAnimatedColorEffect", "CreateanAnimatedColorEffectperObject" : "CreateanAnimatedColorEffectperObject"});

export default SPLM;